import React from "react";
import { Link } from "react-router-dom";

const NotFoundPage = () => (
    <section className="container-x py-20 text-center" data-testid="not-found-page">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#E31837]">404</p>
        <h1 className="font-display font-bold text-3xl md:text-4xl text-[#0A2540] mt-2">Page not found</h1>
        <p className="text-sm text-[#4a4a52] mt-3 max-w-md mx-auto">
            That link doesn&apos;t match a bike, article, or page on Servall Bikes.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-6">
            <Link to="/" className="btn btn-primary">Back home</Link>
            <Link to="/bikes" className="btn btn-white">Browse bikes</Link>
        </div>
    </section>
);

export default NotFoundPage;
